import React, { useState } from "react";
import { Download, Plus, Sparkles } from "lucide-react";
import { useNavigate } from "react-router";

import { Button } from "../../../components/ui/button";
import { useNotification } from "../../../contexts/NotificationContext";
import { SEED_ZONES } from "../../../lib/pricing";
import { seedPricing } from "../../pricing/repository";

export default function EmptyPricingState() {
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  const handleSeed = async () => {
    setLoading(true);
    try {
      await seedPricing();
      showNotification("success", "Tabela de exemplo carregada. Revise os valores.");
    } catch {
      showNotification("error", "Não foi possível carregar a tabela de exemplo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4 rounded-3xl border border-dashed border-white/15 bg-white/5 p-6 text-center">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/20 text-primary">
        <Sparkles className="h-6 w-6" />
      </div>
      <div>
        <h2 className="text-lg font-semibold">Nenhuma tabela cadastrada</h2>
        <p className="mt-1 text-sm text-white/60">
          Carregue a tabela de exemplo ({SEED_ZONES.length} regiões com valores por faixa de
          passageiros) e ajuste os preços, ou comece do zero.
        </p>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
        <Button onClick={handleSeed} disabled={loading}>
          <Download className="h-4 w-4" /> Carregar tabela de exemplo
        </Button>
        <Button
          variant="outline"
          className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white"
          onClick={() => navigate("/admin-management/others/pricing/zones/add")}
        >
          <Plus className="h-4 w-4" /> Criar primeira região
        </Button>
      </div>
    </div>
  );
}
